import { Drawer } from '../../components/Drawer';
import {
  Container,
  Item,
  ItemButton,
  ItemLabel,
  List,
  Thumbnail,
  ThumbnailImage,
  ThumbnailPlaceholder,
  Title,
} from './MenuDrawer.styles';
import type { MenuDrawerProps } from './MenuDrawer.types';

export function MenuDrawer({
  open,
  onClose,
  title,
  closeLabel,
  items,
  noImageLabel,
  desktopOffset,
  width,
}: MenuDrawerProps) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      aria-label={title}
      closeLabel={closeLabel}
      placement="left"
      desktopOffset={desktopOffset}
      width={width}
    >
      <Container>
        <Title>{title}</Title>
        <List>
          {items.map((item) => (
            <Item key={item.id}>
              <ItemButton
                type="button"
                onClick={item.onSelect}
                $active={item.active}
                aria-current={item.active ? 'page' : undefined}
              >
                <Thumbnail>
                  {item.imageUrl ? (
                    <ThumbnailImage src={item.imageUrl} alt="" />
                  ) : (
                    <ThumbnailPlaceholder aria-hidden="true">{noImageLabel}</ThumbnailPlaceholder>
                  )}
                </Thumbnail>
                <ItemLabel>{item.label}</ItemLabel>
              </ItemButton>
            </Item>
          ))}
        </List>
      </Container>
    </Drawer>
  );
}
